import React from 'react';
import { Helmet } from 'react-helmet-async';

import Stats from '../../../components/Global/BannerCard/Stats/Stats';
import LIRC from '../../../components/Global/BannerCard/LIRC/LIRC';
import ExpertiseSection from '../../../components/Global/BannerCard/Expertise/ExpertiseSection';
import THC from '../../../components/Global/BannerCard/T&HC/THC';
import MakeTheShift from '../../../components/MakeTheShift/MakeTheShift';
import CyientGrid from '../../../components/Global/BannerCard/CyientGrid/CyientGrid';

const Plant = () => {
  return (
    <div>

      <Helmet>
        <title>Adithya Infinity</title>
        <meta
          name="description"
          content="Explore how Adithya Infinity Pvt. Ltd. supports IT and Non-IT careers through stats, expertise, and transformative hiring collaborations with live clients."
        />
        <meta
          name="keywords"
          content="Adithya Infinity, Plant Page, Industry Stats, Expertise, Training, Hiring Support, Client Projects"
        />
        <meta name="author" content="Adithya Infinity Pvt. Ltd." />
        <meta name="robots" content="index, follow" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Adithya Infinity | Training & Hiring Expertise" />
        <meta
          property="og:description"
          content="Learn how Adithya Infinity empowers job seekers and businesses with professional development, live projects, and hiring solutions."
        />
        <meta
          property="og:image"
          content="https://img.freepik.com/free-photo/medium-shot-people-working-office_23-2150323516.jpg"
        />
        <meta property="og:url" content="https://yourdomain.com/plant" />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Plant Page - Adithya Infinity Pvt. Ltd.",
            url: "https://yourdomain.com/plant",
            description:
              "Explore Adithya Infinity’s training, hiring, and client project expertise in this overview page.",
            publisher: {
              "@type": "Organization",
              name: "Adithya Infinity Pvt. Ltd.",
              url: "https://yourdomain.com"
            }
          })}
        </script>
      </Helmet>

      <Stats />
      <LIRC />
      <CyientGrid />
      <ExpertiseSection />
      <THC />
      <MakeTheShift />
    </div>
  );
};

export default Plant;
